import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../app/store'
import { type AssetHolderSummary } from '../../../api-schema-types/asset-holdings/AssetHolderDomainDtos'

export interface EditAssetHolderState {
  page: number
  currentAssetHolderId: number | null
  tabIndex: number
  searchResults: AssetHolderSummary[]
}

const initialState: EditAssetHolderState = {
  page: 0,
  currentAssetHolderId: null,
  tabIndex: 0,
  searchResults: []
}

export const editAssetHolderSlice = createSlice({
  name: 'editAssetHolder',
  initialState,
  reducers: {
    setDataGridPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload
    },
    setCurrentAssetHolderId: (state, action: PayloadAction<number | null>) => {
      state.currentAssetHolderId = action.payload
    },
    setTabIndex: (state, action: PayloadAction<number>) => {
      state.tabIndex = action.payload
    },
    setSearchResults: (state, action: PayloadAction<AssetHolderSummary[]>) => {
      state.searchResults = action.payload
    },
    resetEditAssetHolder: (state) => {
      state.currentAssetHolderId = null
      state.tabIndex = 0
      state.searchResults = []
    }
  }
})

export const {
  setDataGridPage,
  setCurrentAssetHolderId,
  setTabIndex,
  setSearchResults,
  resetEditAssetHolder
} = editAssetHolderSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectDataGridPage = (state: RootState): number => state.editAssetHolder.page
export const selectCurrentAssetHolderId = (state: RootState): number | null => state.editAssetHolder.currentAssetHolderId
export const selectTabIndex = (state: RootState): number => state.editAssetHolder.tabIndex
export const selectSearchResults = (state: RootState): AssetHolderSummary[] => state.editAssetHolder.searchResults

export default editAssetHolderSlice.reducer
